import React from 'react';
import {
  CalendarToday,
  LocationOn,
  People,
  Restaurant,
  Public,
  Warning,
  Diversity3
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import ImageCarousel from '../../components/events/ImageCarousel';
import EventMeta from '../../components/events/EventMeta';
import KeyTakeaways from '../../components/events/KeyTakeaways';
import styled from 'styled-components';

const ClosingMessage = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-top: 48px;
  margin-bottom: 60px;
  border: 1px solid rgba(0,0,0,0.1);

  h3 {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-text);
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    color: var(--color-text-light);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const Evenement = () => {
  const eventData = {
    title: "SHALOM's Second Participation at Vivapoly",
    description: "Our return to EPFL's Vivapoly festival presented both highlights and challenges. While we proudly served traditional Israeli falafels and shared our culture, the event was disrupted by unexpected protests, testing our resilience and commitment to peaceful cultural exchange.",
    date: "22/05/2025",
    location: "EPFL Campus - Vivapoly Festival",
    category: "Association Event",
    media: [
      { src: "/events/vivap25/vivap1.jpeg", objectFit: 'cover', objectPosition: '50% 65%' },
      { src: "/events/vivap25/vivap2.jpeg", objectFit: 'cover', objectPosition: '50% 50%' },
      { src: "/events/vivap25/vivap3.jpeg", objectFit: 'cover', objectPosition: '50% 70%' }
    ],
    keyTakeaways: [
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Cultural Sharing',
        description: "Successfully shared Israeli cuisine through our popular falafel stand, continuing last year's tradition.",
        color: '#4F8EF7'
      },
      {
        icon: <Warning style={{ fontSize: '24px' }} />,
        title: 'Unexpected Challenges',
        description: "Faced and handled disruptive protests while maintaining our commitment to peaceful cultural exchange.",
        color: '#FF6B9D'
      },
      {
        icon: <Diversity3 style={{ fontSize: '24px' }} />,
        title: 'Dialogue Promotion',
        description: 'Remained committed to our mission of fostering understanding despite challenges.',
        color: '#9C88FF'
      },
      {
        icon: <Public style={{ fontSize: '24px' }} />,
        title: 'Learning Experience',
        description: 'Demonstrated resilience and adaptability in face of opposition to cultural exchange.',
        color: '#FFB74D'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4F8EF7, #9C88FF)',
      title: eventData.date,
      subtitle: 'Event Date'
    },
    {
      icon: <LocationOn style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: eventData.location,
      subtitle: 'Location'
    },
    {
      icon: <People style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: 'Mixed Reception',
      subtitle: 'Event Impact'
    }
  ];

  return (
    <EventLayout>
      <BackButton />
      <EventHero
        category={eventData.category}
        title={eventData.title}
        description={eventData.description}
      >
        <EventMeta items={metaItems} />
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
      />

      <KeyTakeaways items={eventData.keyTakeaways} />

      <ClosingMessage>
        <h3>Standing Strong for Cultural Dialogue</h3>
        <p>
          Our second participation in Vivapoly was meant to be a joyful celebration of Israeli culture and community. We were proud to welcome students and staff to our stand with music, conversation, and our signature falafel. However, the event was unexpectedly disrupted by a group of protesters who sought to politicize and intimidate our presence.
          <br /><br />
          In the face of this targeted disruption, we stood calmly and firmly by our values: openness, mutual respect, and cultural exchange. We are grateful for the many members of the EPFL community—including fellow students, visitors, and supporters—who expressed solidarity with us during and after the incident.
          <br /><br />
          While the protest was deeply disappointing, it has only reinforced our commitment to our mission. The SHALOM Association exists to create space for dialogue, not division. We believe that campuses must remain places where every student—regardless of background—can express their identity peacefully and proudly.
          <br /><br />
          We thank the EPFL administration and security teams for their eventual intervention, and we call on our academic community to continue upholding the principles of respect, inclusion, and freedom from harassment.
          <br /><br />
          Our resilience is not only in standing firm—but in continuing to build bridges, even when others try to tear them down.
        </p>
      </ClosingMessage>
    </EventLayout>
  );
};

export default Evenement;